import axiosInstance from './api.service'
import constants from '../constants/constants'

const endpointOrigin = "CompanyBonusLevel/";

const Save = async (model) => await axiosInstance.post(endpointOrigin + 'Save', model, constants.REQUIRE_INTERCEPTORS)

const Get = async (id) => await axiosInstance.get(endpointOrigin + `?id=${id}`, constants.REQUIRE_INTERCEPTORS)

const GetAll = async (companyId) => await axiosInstance.get(endpointOrigin + `GetAll?companyId=${companyId}`, constants.REQUIRE_INTERCEPTORS)

const Check = async (breakpoint, companyId) => await axiosInstance.get(endpointOrigin + `Check?breakpoint=${breakpoint}&companyId=${companyId}`, constants.REQUIRE_INTERCEPTORS)

const Toggle = async (id) => await axiosInstance.get(endpointOrigin + `Toggle?id=${id}`, constants.REQUIRE_INTERCEPTORS)

const Delete = async (id) => await axiosInstance.get(endpointOrigin + `Delete?id=${id}`, constants.REQUIRE_INTERCEPTORS)

export {
    Save,
    GetAll,
    Get,
    Check,
    Toggle,
    Delete
}